class DefaultNoProfileAggregator {
    aggregateSemanticModelClass(entity) {
        return {
            ...entity,
            conceptIris: [entity.id],
        };
    }
    aggregateSemanticModelRelationship(entity) {
        return {
            ...entity,
            ends: entity.ends.map(end => ({
                ...end,
                conceptIris: [end.iri],
            })),
        };
    }
}
export function createDefaultNoProfileAggregator() {
    return new DefaultNoProfileAggregator();
}
//# sourceMappingURL=no-profile-aggregator.js.map